import { useState } from 'react';

const PHONE = '905055600419';

const buildWhatsAppMsg = (service: string) => {
  const msg = `Merhaba, ${service} için randevu almak istiyorum.\n\nAd Soyad:\nTelefon:\nKonum:\nTarih:\nSaat:`;
  return `https://wa.me/${PHONE}?text=${encodeURIComponent(msg)}`;
};

const priceItems = [
  { name: 'Mindersiz koltuk takımı', price: '1.000 TL' },
  { name: 'Köşe koltuk (minder, puf, berjer hariç)', price: '1.000 TL' },
  { name: 'Minder / Yastık (adet)', price: '50 TL' },
  { name: 'İki kişilik yatak', price: '700 TL' },
  { name: 'Tek kişilik yatak', price: '600 TL' },
  { name: 'Sandalye (adet)', price: '100 TL' },
  { name: 'Puf', price: '150 TL' },
  { name: 'Ekstra berjer', price: '250 TL' },
  { name: "Ekstra 3'lü koltuk", price: '350 TL' },
];

const variableServices = [
  { icon: 'ri-building-2-line', title: 'İnşaat Sonrası Temizlik', desc: 'Alan büyüklüğüne ve iş kapsamına göre fiyatlandırılır.' },
  { icon: 'ri-window-line', title: 'Dış Cephe Cam Temizliği', desc: 'Bina yüksekliği ve cam alanı keşif sonrası belirlenir.' },
  { icon: 'ri-hotel-bed-line', title: 'Otel Yatak Yıkama', desc: 'Adet ve koşullara göre toplu fiyat sunulur.' },
  { icon: 'ri-layout-grid-line', title: 'Yerinde Halı / Halıfleks Yıkama', desc: 'Metrekare ve halı türüne göre fiyat belirlenmektedir.' },
];

const trustBadges = [
  { icon: 'ri-award-line', label: '18 Yıllık Tecrübe' },
  { icon: 'ri-tools-line', label: 'Profesyonel Ekipman' },
  { icon: 'ri-home-4-line', label: 'Evde Hizmet' },
  { icon: 'ri-building-4-line', label: 'Kurumsal Hizmet' },
  { icon: 'ri-price-tag-3-line', label: 'Uygun Fiyat' },
];

export default function PricingSection() {
  const [tableOpen, setTableOpen] = useState(false);

  return (
    <section id="fiyatlar" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">

        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-emerald-100 text-emerald-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4 animate-pulse">
            Kampanya Fiyatı
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4">
            Kampanyalı Fiyatlarımız
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            Profesyonel temizlik hizmetlerinde uygun fiyatlı kampanya fırsatları
          </p>
          {/* Urgency */}
          <div className="mt-5 inline-flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-700 text-sm font-medium px-5 py-2.5 rounded-full">
            <i className="ri-time-line" />
            Kampanya fiyatları sınırlı süreli olabilir — Hızlı randevu için hemen iletişime geçin
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-3 mb-14">
          {trustBadges.map((b) => (
            <div key={b.label} className="flex items-center gap-2 bg-slate-50 border border-slate-200 text-slate-700 text-sm font-medium px-4 py-2 rounded-full">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${b.icon} text-sky-600 text-base`} />
              </div>
              {b.label}
            </div>
          ))}
        </div>

        {/* HERO PRICE CARD */}
        <div className="max-w-2xl mx-auto mb-16">
          <div className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-3xl p-8 md:p-12 text-center overflow-hidden">
            {/* Decorative circles */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-sky-500/10 rounded-full -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-emerald-500/10 rounded-full translate-y-1/2 -translate-x-1/2" />

            <div className="relative z-10">
              <span className="inline-block bg-emerald-500 text-white text-xs font-bold px-4 py-1.5 rounded-full mb-5 tracking-wide uppercase">
                En Popüler
              </span>
              <h3 className="text-white text-2xl md:text-3xl font-bold mb-2">Mindersiz Koltuk Takımı</h3>
              <p className="text-slate-400 text-sm mb-6">Profesyonel buharlı derin temizleme · Fabrika tazeliği</p>
              <div className="mb-8">
                <span className="text-6xl md:text-7xl font-extrabold text-white tracking-tight">1.000</span>
                <span className="text-2xl font-bold text-sky-400 ml-2">TL</span>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <a
                  href={buildWhatsAppMsg('Mindersiz Koltuk Takımı Yıkama')}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-white font-bold px-7 py-3.5 rounded-full transition-all whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-lg" />
                  WhatsApp ile Yaz
                </a>
                <a
                  href="#iletisim"
                  className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold px-7 py-3.5 rounded-full transition-all whitespace-nowrap border border-white/20"
                >
                  <i className="ri-calendar-check-line" />
                  Hemen Randevu Al
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* SPECIAL SERVICE CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {/* Petek */}
          <div className="group relative bg-gradient-to-br from-orange-50 to-amber-50 border border-amber-200 rounded-2xl p-8 overflow-hidden hover:-translate-y-1 transition-all duration-300">
            <div className="absolute top-4 right-4 bg-amber-500 text-white text-xs font-bold px-3 py-1.5 rounded-full">Sabit Fiyat</div>
            <div className="w-14 h-14 flex items-center justify-center bg-amber-100 rounded-2xl mb-5">
              <i className="ri-fire-line text-amber-600 text-2xl" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-1">Petek Temizliği</h3>
            <p className="text-slate-500 text-sm mb-5">Kombi altı filtre temizliği dahil — Isıtma verimi artar, enerji tasarrufu sağlanır</p>
            <div className="flex items-baseline gap-2 mb-6">
              <span className="text-5xl font-extrabold text-amber-600">1.000</span>
              <span className="text-xl font-bold text-amber-500">TL</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a href={buildWhatsAppMsg('Petek Temizliği')} target="_blank" rel="nofollow noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-5 py-3 rounded-full transition-all whitespace-nowrap text-sm">
                <i className="ri-whatsapp-line" /> WhatsApp ile Yaz
              </a>
              <a href="tel:05055600419"
                className="inline-flex items-center justify-center gap-2 bg-slate-800 hover:bg-slate-700 text-white font-semibold px-5 py-3 rounded-full transition-all whitespace-nowrap text-sm">
                <i className="ri-phone-line" /> Hemen Ara
              </a>
            </div>
          </div>

          {/* Araç */}
          <div className="group relative bg-gradient-to-br from-sky-50 to-blue-50 border border-sky-200 rounded-2xl p-8 overflow-hidden hover:-translate-y-1 transition-all duration-300">
            <div className="absolute top-4 right-4 bg-sky-600 text-white text-xs font-bold px-3 py-1.5 rounded-full">Sabit Fiyat</div>
            <div className="w-14 h-14 flex items-center justify-center bg-sky-100 rounded-2xl mb-5">
              <i className="ri-car-line text-sky-600 text-2xl" />
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-1">Araç Koltuk Temizliği</h3>
            <p className="text-slate-500 text-sm mb-5">Araç içi koltuk ve yüzey temizliği — Profesyonel ekipman, hijyenik sonuç</p>
            <div className="flex items-baseline gap-2 mb-6">
              <span className="text-5xl font-extrabold text-sky-600">1.000</span>
              <span className="text-xl font-bold text-sky-500">TL</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <a href={buildWhatsAppMsg('Araç Koltuk Temizliği')} target="_blank" rel="nofollow noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold px-5 py-3 rounded-full transition-all whitespace-nowrap text-sm">
                <i className="ri-whatsapp-line" /> WhatsApp ile Yaz
              </a>
              <a href="tel:05055600419"
                className="inline-flex items-center justify-center gap-2 bg-slate-800 hover:bg-slate-700 text-white font-semibold px-5 py-3 rounded-full transition-all whitespace-nowrap text-sm">
                <i className="ri-phone-line" /> Hemen Ara
              </a>
            </div>
          </div>
        </div>

        {/* QUICK PRICE TABLE */}
        <div className="mb-16">
          <div
            className="bg-slate-50 border border-slate-200 rounded-2xl overflow-hidden"
          >
            <button
              type="button"
              onClick={() => setTableOpen(!tableOpen)}
              className="w-full flex items-center justify-between px-6 md:px-8 py-5 text-left cursor-pointer hover:bg-slate-100 transition-colors"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-sky-100 rounded-xl">
                  <i className="ri-list-check-2 text-sky-600 text-lg" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-slate-900">Hızlı Fiyat Listesi</h3>
                  <p className="text-slate-500 text-sm">Tüm hizmet fiyatlarına göz atın</p>
                </div>
              </div>
              <div className="w-8 h-8 flex items-center justify-center bg-sky-100 rounded-full flex-shrink-0">
                <i className={`${tableOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-sky-600 text-lg`} />
              </div>
            </button>

            {tableOpen && (
              <div className="border-t border-slate-200">
                <div className="px-4 md:px-8 py-4">
                  <div className="divide-y divide-slate-100">
                    {priceItems.map((item, i) => (
                      <div
                        key={item.name}
                        className={`flex items-center justify-between py-4 gap-4 ${i % 2 === 0 ? '' : 'bg-slate-50/50'}`}
                      >
                        <div className="flex items-center gap-3">
                          <div className="w-2 h-2 rounded-full bg-sky-400 flex-shrink-0" />
                          <span className="text-slate-700 text-sm md:text-base font-medium">{item.name}</span>
                        </div>
                        <div className="flex items-center gap-3 flex-shrink-0">
                          <span className="text-lg md:text-xl font-bold text-sky-600">{item.price}</span>
                          <a
                            href={buildWhatsAppMsg(item.name)}
                            target="_blank"
                            rel="nofollow noreferrer"
                            className="inline-flex items-center justify-center w-8 h-8 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full transition-all"
                            title="WhatsApp ile Randevu Al"
                          >
                            <i className="ri-whatsapp-line text-sm" />
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="px-4 md:px-8 pb-6 pt-2">
                  <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-information-line text-amber-600" />
                    </div>
                    <p className="text-amber-700 text-sm">
                      Yoğunluk nedeniyle randevu saatleri değişebilir. Hızlı randevu için hemen iletişime geçin.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* VARIABLE PRICE SERVICES */}
        <div>
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2">Proje Bazlı Hizmetler</h3>
            <p className="text-slate-500">Fiyat iş kapsamına göre belirlenmektedir</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {variableServices.map((svc) => (
              <div key={svc.title} className="bg-slate-50 border border-slate-200 rounded-2xl p-6 flex flex-col gap-4 hover:border-sky-200 hover:bg-sky-50/30 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center bg-slate-100 rounded-xl">
                  <i className={`${svc.icon} text-slate-600 text-xl`} />
                </div>
                <div>
                  <h4 className="text-base font-bold text-slate-900 mb-1">{svc.title}</h4>
                  <p className="text-slate-500 text-xs leading-relaxed">{svc.desc}</p>
                </div>
                <p className="text-xs font-semibold text-amber-600 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
                  Fiyat iş kapsamına göre belirlenmektedir
                </p>
                <div className="flex flex-col gap-2 mt-auto">
                  <a href={buildWhatsAppMsg(svc.title)} target="_blank" rel="nofollow noreferrer"
                    className="inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-semibold px-4 py-2.5 rounded-full transition-all whitespace-nowrap">
                    <i className="ri-whatsapp-line" /> WhatsApp ile Sor
                  </a>
                  <a href="tel:05055600419"
                    className="inline-flex items-center justify-center gap-2 border border-slate-300 hover:border-slate-400 text-slate-700 text-xs font-semibold px-4 py-2.5 rounded-full transition-all whitespace-nowrap">
                    <i className="ri-phone-line" /> Hemen Ara
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
